<template>
    <div class="loading-spinner">
        <div class="loading"></div>
    </div>
</template>

<style>
.loading-spinner {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
}

.loading {
    position: relative;
    width: 12px;
    height: 12px;
    border-radius: 12px;
    background-color: #ccc;
    -webkit-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
    -webkit-animation: loading 1s ease-in-out infinite;
    animation: loading 1s ease-in-out infinite;
}

.loading:before {
    content: "";
    position: absolute;
    background-color: #ccc;
    top: 0px;
    left: -25px;
    height: 12px;
    width: 12px;
    border-radius: 12px;
}

.loading:after {
    content: "";
    position: absolute;
    background-color: #ccc;
    top: 0px;
    left: 25px;
    height: 12px;
    width: 12px;
    border-radius: 12px;
}

@-webkit-keyframes loading {
    0% { -webkit-transform: rotate(0deg); }
    50% { -webkit-transform: rotate(180deg); }
    100% { -webkit-transform: rotate(180deg); }
}

@keyframes loading {
    0% { transform: rotate(0deg); }
    50% { transform: rotate(180deg); }
    100% { transform: rotate(180deg); }
}
</style>